import React from 'react'
import { Link } from 'gatsby'
import { Flex, Box, Heading, Button } from 'rebass/styled-components'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import PropTypes from 'prop-types'

import { getDashboardCreateUserURL } from '../../utils/cta-utils'

const ContactSection = ({ noBorder }) => {
  const { t } = useTranslation('comoon')
  return (
    <Flex
      as="section"
      flexDirection="column"
      width={1}
      pt={noBorder ? [8, 8, 12] : ['200px', '260px', '280px']}
      px={[5, 5, 0]}
      pb={[15, 15, 25]}
      sx={{
        backgroundImage: 'url(/purpleBg.png)',
        backgroundPosition: 'bottom center',
        backgroundRepeat: 'repeat-y',
        backgroundSize: 'cover'
      }}
    >
      <Box
        maxWidth="container"
        width={1}
        mx="auto"
        pt={[15, 15, 20]}
        sx={{
          borderTop: noBorder ? '' : '1px solid rgba(255,255,255, 0.2)'
        }}
      >
        <Heading width={[1, '650px']} mb={10} variant="level2" color="white">
          {t('contact.title')}
        </Heading>

        <Flex flexDirection="row" justifyContent={['space-between', 'flex-start']} mt={10}>
          <Link to={getDashboardCreateUserURL()}>
            <Button
              width={['157px', '220px']}
              mr={[0, 5]}
              sx={{
                '&:hover': {
                  bg: 'white'
                }
              }}
            >
              {t('contact.buttons.start.text')}
            </Button>
          </Link>

          <Link to={t('contact.buttons.contact.link')}>
            <Button width={['157px', '220px']} height="55px" variant="tertiary">
              {t('contact.buttons.contact.text')}
            </Button>
          </Link>
        </Flex>
      </Box>
    </Flex>
  )
}

ContactSection.propTypes = {
  noBorder: PropTypes.bool
}

export default ContactSection
